export const makeTableList = (allowForecastsWhitoutConsensus, view) => {
  if (allowForecastsWhitoutConsensus) {
    return [
      'header',
      view === 'actuals' ? 'forecast' : 'forecast_yoy',
      view === 'actuals' ? 'reported' : 'reported_yoy',
      'forecast_error',
    ];
  }

  return [
    'header',
    'forecast',
    'consensus',
    'forecast_yoy',
    'consensus_yoy',
    'forecast_error',
  ];
};

export const tableNames = {
  header: undefined,
  forecast: 'Apptopia Forecast',
  reported: 'Company Reported',
  consensus: 'Consensus',
  forecast_yoy: 'YoY Apptopia Forecast',
  reported_yoy: 'YoY Company Reported',
  consensus_yoy: 'YoY Consensus',
  forecast_error: 'Forecast % Error',
};
